module.exports = __webpack_public_path__ + "media/images/city/099-great-wall-of-china-d64cd5979fec2d77d8459687858a444e.svg";